/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { Icon } from './Icon';

export namespace ParticipantsIcon {
  export interface Props extends Icon.Props {}
}

export const ParticipantsIcon: React.FC<Icon.Props> = ({ fill = 'none', stroke = undefined, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={fill}
    stroke={stroke}
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16 11.4286C17.66 11.4286 18.99 9.99286 18.99 8.21429C18.99 6.43571 17.66 5 16 5C14.34 5 13 6.43571 13 8.21429C13 9.99286 14.34 11.4286 16 11.4286ZM8 11.4286C9.66 11.4286 10.99 9.99286 10.99 8.21429C10.99 6.43571 9.66 5 8 5C6.34 5 5 6.43571 5 8.21429C5 9.99286 6.34 11.4286 8 11.4286ZM8 13.5714C5.67 13.5714 1 14.825 1 17.3214V20H15V17.3214C15 14.825 10.33 13.5714 8 13.5714ZM16 13.5714C15.71 13.5714 15.38 13.5929 15.03 13.625C16.19 14.525 17 15.7357 17 17.3214V20H23V17.3214C23 14.825 18.33 13.5714 16 13.5714Z" />
  </svg>
);
